// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"styles_feedbackContainer__znKrN","feedbackCard":"styles_feedbackCard__3TIBt"};